import React from 'react';
import PropTypes from 'prop-types';

import LoadingDots from 'components/LoadingDots';

import InstructorForm from './InstructorFormContainer';

const InstructorEditForm = ({ isInstructorLoading, ...restProps }) => {
  if (isInstructorLoading) return <LoadingDots />;

  return <InstructorForm {...restProps} />;
};

InstructorEditForm.propTypes = {
  isInstructorLoading: PropTypes.bool,
};

export default InstructorEditForm;
